import React from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDeleteChat } from "../../../queries/chatActions";

const DeleteChatModal = ({ isOpen, onClose, id, fetchChats, navigateBack }) => {
  const navigate = useNavigate();
  const { mutate: deleteChat, isPending: loading } = useDeleteChat();

  const handleDeleteClick = () => {
    deleteChat(id, {
      onSuccess: (response) => {
        if (response?.success) {
          navigateBack && navigate("/app/chat");
          fetchChats();
          onClose();
        }
      },
    });
  };
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      showAlert={false}
      title={
        <p className="text-center text-[18px] font-bold font-Inter">
          Delete Chat
        </p>
      }
    >
      <p className="text-[14px] text-foreground font-[600] font-Inter">
        You're about to delete this chat. This action is permanent and cannot be
        undone.
      </p>
      <div className="mt-5 flex items-center justify-end gap-3">
        <Button
          className="!bg-[#FEE9E7] !text-[#C00F0C]"
          sx={{ border: "1px solid #FEE9E7" }}
          onClick={() => handleDeleteClick()}
          disabled={loading}
        >
          Delete
        </Button>
        <Button
          className="!bg-card !text-foreground"
          sx={{ border: "1px solid hsl(var(--border))" }}
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </CommonModal>
  );
};

export default DeleteChatModal;
